export default class JsonLd {
  constructor (type, context = 'https://schema.org') {
    this['@context'] = context
    this['@type'] = type
  }

  static create ({ type, context }) {
    return new JsonLd(type, context)
  }

  toString () {
    return JSON.stringify(this)
  }

  injectIntoDOM () {
    return <script type="application/ld+json">{this.toString()}</script>
  }
}
